import React from 'react'
import { IconTypeProps } from '../icon';

export function IconThreeDots({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 29 8"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="4" cy="4" r="3.5" stroke="white" />
      <circle cx="14.2856" cy="4" r="3.5" stroke="white" />
      <circle cx="24.5715" cy="4" r="3.5" stroke="white" />
    </svg>
  );
}
